<section>
    <div class="container">
        <div class="heading">
            <div class="vt-line"><span></span></div>
            <div class="row">
                <div class="col hr-line"><span></span></div>
                <h2 class="col-auto s-font h-large">The Best Product</h2>
                <div class="col"></div>
            </div>
        </div>
        <div class="row content">
            <div class="col-md col_1 row">
                <div class="col text">
                    <h2 class="h-large s-font color-orange">Skincare</h2>
                    <!-- p>올레뉴는 코스메슈티컬 올인원 전문 기업으로
                        제조사 삼성메디코스와 협력하여 피부에 효과적인 천연성분을 기반으로
                        피부 솔루션을 제고하는올인원 전문 화장품 회사 입니다.</p -->
                    <a class="w-btn rounded-btn medium-btn s-font" (click)="handleOnClickProductDetail('09000006');">
                        <span>MORE</span>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path
                                d="M0 6.00008L5.99996 6.00008M5.99996 6.00008L12 6.00008M5.99996 6.00008V0M5.99996 6.00008V12"
                                stroke="#584E3F" stroke-width="1" />
                        </svg>
                    </a>
                </div>
                <div class="col-auto img">
                    <img src="./assets/img/02.png">
                </div>
            </div>
            <div class="col-md col_2 row">
                <div class="col-auto img">
                    <img src="./assets/img/03.png">
                </div>
                <div class="col text">
                    <h2 class="h-large s-font color-orange">Cleansing</h2>
                    <!-- p>올레뉴는 코스메슈티컬 올인원 전문 기업으로
                        제조사 삼성메디코스와 협력하여 피부에 효과적인 천연성분을 기반으로
                        피부 솔루션을 제고하는올인원 전문 화장품 회사 입니다.</p -->
                    <a class="w-btn rounded-btn medium-btn s-font" (click)="handleOnClickProductDetail('09000007');">
                        <span>MORE</span>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path
                                d="M0 6.00008L5.99996 6.00008M5.99996 6.00008L12 6.00008M5.99996 6.00008V0M5.99996 6.00008V12"
                                stroke="#584E3F" stroke-width="1" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="e-img" src="./assets/img/04.png">
    <img class="bg" src="./assets/img/01.svg">
</section>